export default __webpack_public_path__ + "static/marvel-sw-cadc429414e31cfed2595d20ccfe894b.jpg";